import { FC, useContext } from 'react';
import { GroupedDataPieChart } from '../../../../../../Components/Charts';
import { emptyGuid } from '../../../../../../models';
import { useGetCompanySurveysByStatusQuery } from '../../../../../../store';
import { CompanyDashboardContext } from '../../../../Utils';
import { DataFilterContext } from '../../../../../../Contexts';

const COLOR_PALLET = new Map([
    ['Issued', '#BFBFBF'],
    ['Scheduled', '#97CBD2'],
    ['Pending', '#57585A'],
]);

export const CompanyDashboardSurveysTabSidebarContent: FC = () => {
    const { company } = useContext(CompanyDashboardContext);
    const {
        statusFilter,
        formTypeFilter,
        reminderFilter,
        approvedByFilter,
        scheduledFromDateFilter: fromDateFilter,
        scheduledToDateFilter: toDateFilter,
        periodStartDateFilter,
        periodEndDateFilter,
        setStatusFilter,
        studyFilter
    } = useContext(DataFilterContext);
    const { data: workItemStats, isLoading } = useGetCompanySurveysByStatusQuery({ companyId: company.id ?? emptyGuid, searchParams: {
        status: statusFilter,
        formType: formTypeFilter,
        reminder: reminderFilter,
        approvedBy: approvedByFilter,
        fromDate: fromDateFilter ?? undefined,
        toDate: toDateFilter ?? undefined,
        periodStartDate: periodStartDateFilter ?? undefined,
        periodEndDate: periodEndDateFilter ?? undefined,
        assignedToStudyId: studyFilter
    }});

    return <GroupedDataPieChart name='Survey Status' groupedData={workItemStats ?? []} onSliceClicked={setStatusFilter} colorMap={COLOR_PALLET} isLoading={isLoading} />;
};